import { getCurrentUserQueryOptions } from "@/users/operations/get-current-user/getCurrentUserQueryOptions";
import { useQuery } from "@tanstack/react-query";
import { buildPushNotificationsPermissionsQuery } from "../hooks/buildPushNotificationsPermissionsQuery";
import { buildGetPreferencesQuery } from "@/common/hooks/buildGetPreferencesQuery";
import {
	PUSH_PREF_KEY,
	PushNotificationsPermissionsModal,
} from "./PushNotificationsPermissionsModal";
import { useEffect, useState } from "react";
import { canPromptForPushNotificationsPermissions } from "../utils/canPromptForPushNotificationsPermissions";
import { UserRole } from "@/users/models/UserRole";

export function PushNotificationsPrompter() {
	const [opened, setOpened] = useState(false);
	const pushNotificationsPermissionQuery = useQuery(
		buildPushNotificationsPermissionsQuery(),
	);
	const pushNotificationsPrefQuery = useQuery(
		buildGetPreferencesQuery({ key: PUSH_PREF_KEY }),
	);

	const currentUserQuery = useQuery(getCurrentUserQueryOptions());

	useEffect(() => {
		// Caregivers handle notification permissions via the onboarding flow
		if (currentUserQuery.data?.role === UserRole.Caregiver) return;

		if (
			currentUserQuery.data &&
			canPromptForPushNotificationsPermissions(
				pushNotificationsPermissionQuery,
			) &&
			// check preferences to prevent the popup from appearing multiple times but to allow the user to enable notifications later
			// from within the app itself rather than navigating to system settings.
			// on ios if the user denies the native prompt, we can no longer trigger the native prompt from within the app.
			pushNotificationsPrefQuery.data &&
			pushNotificationsPrefQuery.data.value !== "true"
		) {
			setOpened(true);
		}
	}, [
		currentUserQuery.data,
		pushNotificationsPermissionQuery.data,
		pushNotificationsPrefQuery.data,
	]);

	return (
		<PushNotificationsPermissionsModal opened={opened} setOpened={setOpened} />
	);
}
